
import { MassStatusTypes, MassBKGColors } from './mass.types';



export const getMassStatus = (mass) => {


    const { massTimeDate, openTimeDate } = mass;
    const massTD = massTimeDate.getTime();
    const openTD = openTimeDate.getTime();

    const dNow = new Date();
    let dPlus1 = new Date();
    dPlus1.setHours(dPlus1.getHours() + 1);

    let status = MassStatusTypes.MASS_NOT_OPEN;
    //highest priority status is Closed
    if (dPlus1.getTime() > massTD) {
        return MassStatusTypes.MASS_CLOSED; 
    }
    //second is if Mass is Full
    if (getSeatAvailability(mass) <= 0) {
        return MassStatusTypes.MASS_FULL;
    }
    //third if not closed or full check if open 
    if (dNow.getTime() > openTD) {
        return MassStatusTypes.MASS_OPEN;
    }
    //default is it is Not Open
    return status;
};



export const getMassState = (mass) => {
    
    switch  (getMassStatus(mass)) {

        case MassStatusTypes.MASS_CLOSED:
            return {label: 'CLOSED', bkgColor: MassBKGColors.CLOSED_COLOR, isOpen: false };
        
        case MassStatusTypes.MASS_FULL:
            return {label: 'FULL', bkgColor: MassBKGColors.FULL_COLOR, isOpen: false };
        
        case MassStatusTypes.MASS_NOT_OPEN:
            return {label: 'OPEN SOON!', bkgColor: MassBKGColors.OPEN_SOON_COLOR, isOpen: false };
        
        default:
            return {label: null, bkgColor: null, isOpen: true};
    };
};

export const extractTypes= (configArray, currentTypes) => {

    let filteredConfig = configArray.filter( el => {
        return (el.type.substring(0, 4) === 'type');
    });


    if (filteredConfig.length !== 0) {

        filteredConfig.forEach(el => {
            if (el.openForReservations) {
                delete el.openForReservations;
            }
        });
        return filteredConfig;
    }

    console.log("Error: No mass types in config database");
    return currentTypes;
    
};

export const extractGeneration = (configArray, currentGen) => {


    let filteredConfig = configArray.filter( el => {
        return el.type === 'basic';
    });

    if (filteredConfig.length !== 0) {
        if (filteredConfig[0].gen) {
            return filteredConfig[0].gen;
        }
    }
    console.log("Error: No generation in config database");
    
    return currentGen;
};


export const getSeatAvailability = (mass) => {
    const { seatsPerPew, seatsPerSection, availSeats, availSections } = mass;

    const seatLimitForSections = (availSections % 2 === 0) ? 
            Math.floor(availSections / 2) * seatsPerPew : Math.floor(availSections / 2 ) * seatsPerPew + seatsPerSection;
    return Math.min(seatLimitForSections, availSeats);

}

